/**
 * AIMasteringPanelWrapper Component
 * Wrapper for AI Mastering Suggestions panel
 */

import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { AIMasteringPanel } from '../mastering';

export const AIMasteringPanelWrapper = ({
  isOpen,
  onClose,
  projectId,
  projectName,
  audioCharacteristics,
  handleApplyMasteringSuggestion,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <AIMasteringPanel
          isVisible={isOpen}
          onClose={onClose}
          projectId={projectId || 'default'}
          projectName={projectName || 'Untitled Project'}
          audioCharacteristics={audioCharacteristics}
          onApplySuggestion={handleApplyMasteringSuggestion}
        />
      )}
    </AnimatePresence>
  );
};

export default AIMasteringPanelWrapper;
